import { CheckIcon } from "@heroicons/react/solid";
import { useState } from "react";
import { Link } from "react-router-dom";

import mac from "../assets/mac.png";

const includedFeatures = [
  "Bespoke website",
  "Customised to your brand",
  "1-on-1 design consultation",
  "Everything you need to get started",
];

export default function Pricing(props) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
    if (!isModalOpen) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
  };

  return (
    <div className="bg-white dark:bg-olenium-bg pt-24" id={props.id}>
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div
          className="my-8 absolute inset-x-0 -top-3 -z-10 transform-gpu overflow-hidden px-36 blur-3xl"
          aria-hidden="true"
        >
          <div
            className="mx-auto aspect-[1155/678] w-[72.1875rem] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30"
            style={{
              clipPath:
                "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
            }}
          />
        </div>
        <div className="mx-auto max-w-2xl text-center lg:max-w-4xl">
          <h2 className="text-base font-semibold leading-7 text-olenium-blue dark:text-olenium-blue">
            Custom build websites
          </h2>
          <p className="mt-2 text-4xl font-bold tracking-tight text-gray-900 dark:text-white sm:text-5xl">
            Create your project today
          </p>
        </div>
        <p className="mx-auto mt-6 max-w-2xl text-center text-lg leading-8 text-gray-600 dark:text-white">
          Whether you’re a freelancer, a startup, or a small business, we have
          the perfect solution to get you started.
        </p>
        <div class="container py-10 px-10 mx-0 min-w-full flex flex-col items-center">
        <Link
            // link to portal.olenium.com
            to="https://portal.olenium.co.uk"
            className="rounded-md bg-olenium-blue px-3.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-[#309CFF] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-olenium-blue order-3"
          >
            Get started
          </Link>
          </div>
        {/* <div className="mx-auto my-16 max-w-2xl rounded-3xl ring-1 ring-gray-200 sm:mt-20 lg:mx-0 lg:flex lg:max-w-none">
          <div className="p-8 sm:p-10 lg:flex-auto">
            <h3 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
              One Page Website
            </h3>
            <p className="mt-6 text-base leading-7 text-gray-600 dark:text-white">
              Experience a custom-designed one-page website crafted to
              perfection. Our team of experts brings your vision to life with
              creativity and precision.
            </p>
            <div className="mt-10 flex items-center gap-x-4">
              <h4 className="flex-none text-sm font-semibold leading-6 text-olenium-blue dark:text-olenium-blue">
                What's included
              </h4>
              <div className="h-px flex-auto bg-gray-100" />
            </div>
            <ul
              role="list"
              className="mt-8 grid grid-cols-1 gap-4 text-sm leading-6 text-gray-600 dark:text-white sm:grid-cols-2 sm:gap-6"
            >
              {includedFeatures.map((feature) => (
                <li key={feature} className="flex gap-x-3">
                  <CheckIcon
                    className="h-6 w-5 flex-none text-olenium-blue dark:text-olenium-blue"
                    aria-hidden="true"
                  />
                  {feature}
                </li>
              ))}
            </ul>
          </div>
          <div className="-mt-2 p-2 lg:mt-0 lg:w-full lg:max-w-md lg:flex-shrink-0">
            <div className="rounded-2xl bg-gray-50 dark:bg-[#100f0f] py-10 text-center ring-1 ring-inset ring-gray-900/5 lg:flex lg:flex-col lg:justify-center lg:py-16">
              <div className="mx-auto max-w-xs px-8">
                <p className="text-base font-semibold text-gray-900 dark:text-white">
                  Pay once, own it{" "} forever
                </p>
                <p className="mt-6 flex items-baseline justify-center gap-x-2">
                  <span className="text-5xl font-bold tracking-tight text-gray-900 dark:text-white">
                    £995
                  </span>
                  <span className="text-sm font-semibold leading-6 tracking-wide text-[#0085ff]">
                    GBP
                  </span>
                </p>
                <Link
                  to="/get-started"
                  className="mt-8 block w-full rounded-md bg-[#0085ff] px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-olenium-blue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-olenium-blue"
                >
                  Get started
                </Link>
                <p className="mt-6 text-xs leading-5 text-gray-600 dark:text-white">
                  Invoices and receipts available
                </p>
              </div>
            </div>
          </div>
        </div> */}
      </div>
      <div class="bg-white dark:bg-olenium-bg">
        <div class="mx-auto max-w-7xl py-24 sm:px-6 sm:py-32 lg:px-8">
          <div class="relative isolate overflow-hidden bg-gray-900 px-6 pt-16 shadow-2xl sm:rounded-3xl sm:px-16 md:pt-24 lg:flex lg:gap-x-20 lg:px-24 lg:pt-0">
            <svg
              viewBox="0 0 1024 1024"
              class="absolute left-1/2 top-1/2 -z-10 h-[64rem] w-[64rem] -translate-y-1/2 [mask-image:radial-gradient(closest-side,white,transparent)] sm:left-full sm:-ml-80 lg:left-1/2 lg:ml-0 lg:-translate-x-1/2 lg:translate-y-0"
              aria-hidden="true"
            >
              <circle
                cx="512"
                cy="512"
                r="512"
                fill="url(#759c1415-0410-454c-8f7c-9a820de03641)"
                fill-opacity="0.7"
              />
              <defs>
                <radialGradient id="759c1415-0410-454c-8f7c-9a820de03641">
                  <stop stop-color="#7775D6" />
                  <stop offset="1" stop-color="#E935C1" />
                </radialGradient>
              </defs>
            </svg>
            <div class="mx-auto max-w-md text-center lg:mx-0 lg:flex-auto lg:py-32 lg:text-left">
              <h2 className="text-base font-semibold tracking-wide text-white uppercase pb-4">
                Custom build websites
              </h2>
              <h2 class="text-3xl font-bold tracking-tight text-white sm:text-4xl pb-6">
                Looking for a multi-page website instead?
              </h2>
              <p class="mt-6 text-lg leading-8 text-gray-300">
                Connect with our development experts for a consultation. Let's
                explore how we can tailor a multi-page website that fits your
                unique requirements.
              </p>
              <div class="mt-10 flex items-center justify-center gap-x-6 lg:justify-start">
                <a
                  href="https://calendar.app.google/SvtsyuUYwntV6Mqp7"
                  class="rounded-md bg-white px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                >
                  Book a consultation
                </a>
                <button
                  onClick={toggleModal}
                  class="text-sm font-semibold leading-6 text-white"
                >
                  Learn more
                </button>
              </div>
            </div>
            <div class="relative mt-16 h-80 lg:mt-8">
              <img
                class="absolute left-0 top-0 w-[57rem] max-w-none"
                src={mac}
                alt="App screenshot"
                width="1824"
                height="1080"
              />
            </div>
          </div>
        </div>
      </div>
      {isModalOpen && (
        // modal should appear in the middle of the screen
        <div
          className="fixed inset-0 z-10 flex items-center justify-center bg-black bg-opacity-50 backdrop-filter backdrop-blur-lg"
          aria-labelledby="modal-title"
          role="dialog"
          aria-modal="true"
        >
          <div class="relative p-2 w-full max-w-4xl max-h-full">
            <div class="relative bg-white rounded-3xl shadow px-10 pb-10 modal-content">
              <div class="flex items-center justify-between mb-6 md:pt-12">
                <h3 class="text-3xl font-semibold text-gray-800 mt-8 md:mt-0">
                  Custom websites
                </h3>
                <button
                  type="button"
                  class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-200 rounded-lg text-sm h-8 w-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-200 dark:hover:text-white mt-8 md:mt-0"
                  onClick={toggleModal}
                >
                  <svg
                    class="w-3 h-3"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 14 14"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                    />
                  </svg>
                  <span class="sr-only">Close modal</span>
                </button>
              </div>

              <p class="pb-10 text-gray-600">
                Discover the perfect online solution with our custom-built
                websites at One Page. Whether you're a thriving enterprise or a
                growing startup, our bespoke web solutions are crafted to meet
                the diverse needs of your business. From engaging interactive
                sites to comprehensive e-commerce platforms, we specialize in
                creating digital experiences that captivate and convert.
              </p>

              <dl class="grid max-w-xl grid-cols-1 gap-x-8 gap-y-10 lg:max-w-none lg:grid-cols-2 lg:gap-y-16 pb-14">
                <div class="relative pl-16">
                  <dt class="text-base font-semibold leading-7 text-gray-900">
                    <div class="absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-lg bg-olenium-blue">
                      <svg
                        width="22"
                        height="18"
                        viewBox="0 0 22 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clipRule="evenodd"
                          d="M2.87012 9.5H6.37012C6.96685 9.5 7.53915 9.73705 7.96111 10.159C8.38306 10.581 8.62012 11.1533 8.62012 11.75V15.25C8.62012 15.8467 8.38306 16.419 7.96111 16.841C7.53915 17.2629 6.96685 17.5 6.37012 17.5H2.87012C1.62748 17.5 0.620117 16.4926 0.620117 15.25V11.75C0.620117 10.5074 1.62748 9.5 2.87012 9.5ZM6.37012 16C6.78433 16 7.12012 15.6642 7.12012 15.25V11.75C7.12012 11.3358 6.78433 11 6.37012 11H2.87012C2.45816 11.0054 2.1255 11.338 2.12012 11.75V15.25C2.1255 15.662 2.45816 15.9946 2.87012 16H6.37012Z"
                          fill="white"
                        />
                        <path
                          d="M12.6201 10.75C12.2059 10.75 11.8701 11.0858 11.8701 11.5C11.8701 11.9142 12.2059 12.25 12.6201 12.25H17.6201C18.0343 12.25 18.3701 11.9142 18.3701 11.5C18.3701 11.0858 18.0343 10.75 17.6201 10.75H12.6201Z"
                          fill="white"
                        />
                        <path
                          d="M20.6201 14.75H12.6201C12.2059 14.75 11.8701 15.0858 11.8701 15.5C11.8701 15.9142 12.2059 16.25 12.6201 16.25H20.6201C21.0343 16.25 21.3701 15.9142 21.3701 15.5C21.3701 15.0858 21.0343 14.75 20.6201 14.75Z"
                          fill="white"
                        />
                        <path
                          fill-rule="evenodd"
                          clipRule="evenodd"
                          d="M18.6201 7.5H2.62012C1.51555 7.5 0.620117 6.60457 0.620117 5.5V2.5C0.620117 1.39543 1.51555 0.5 2.62012 0.5H18.6201C19.7247 0.5 20.6201 1.39543 20.6201 2.5V5.5C20.6201 6.60457 19.7247 7.5 18.6201 7.5ZM2.62012 2C2.34397 2 2.12012 2.22386 2.12012 2.5V5.5C2.12012 5.77614 2.34397 6 2.62012 6H18.6201C18.8963 6 19.1201 5.77614 19.1201 5.5V2.5C19.1201 2.22386 18.8963 2 18.6201 2H2.62012Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    Dynamic User Experiences
                  </dt>
                  <dd class="mt-2 text-base leading-7 text-gray-600">
                    Engage your audience with interactive and responsive design
                    that adapts to user behavior, ensuring a memorable and
                    impactful user journey.
                  </dd>
                </div>
                <div class="relative pl-16">
                  <dt class="text-base font-semibold leading-7 text-gray-900">
                    <div class="absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-lg bg-olenium-blue">
                      <svg
                        width="22"
                        height="21"
                        viewBox="0 0 22 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clipRule="evenodd"
                          d="M19.28 1.81992L20.94 6.42992C21.3012 7.32256 21.2119 8.33431 20.7 9.14992C20.2644 9.76804 19.6342 10.2223 18.91 10.4399V17.2399C18.8943 18.0038 18.5756 18.7301 18.0242 19.259C17.4728 19.7879 16.7339 20.076 15.97 20.0599H6.31C5.53665 20.0896 4.78371 19.8078 4.21981 19.2778C3.65591 18.7477 3.32818 18.0136 3.31 17.2399V10.5399C2.60595 10.3787 1.97181 9.99679 1.5 9.44991C0.82159 8.60307 0.653338 7.4559 1.06 6.44992L2.71 1.82992C3.09914 0.844627 4.06092 0.2061 5.12 0.229915H16.87C17.9274 0.20157 18.89 0.83663 19.28 1.81992ZM12.3515 18.4299H12.36V18.4599C12.357 18.45 12.3541 18.44 12.3515 18.4299ZM12.3515 18.4299H9.81C9.81952 18.3535 9.81952 18.2763 9.81 18.1999V16.0899C9.82742 15.7726 9.97425 15.4764 10.2162 15.2703C10.4581 15.0643 10.774 14.9666 11.09 14.9999C11.7184 14.9538 12.2669 15.422 12.32 16.0499V18.1899C12.32 18.271 12.3306 18.3517 12.3515 18.4299ZM15.92 18.4299H13.81C13.8195 18.3535 13.8195 18.2763 13.81 18.1999V16.0899C13.7557 14.6174 12.5228 13.4649 11.05 13.5099C9.57333 13.4593 8.33426 14.6134 8.28 16.0899V18.2299C8.27048 18.3063 8.27048 18.3835 8.28 18.4599H6.26C5.52339 18.4939 4.89774 17.9263 4.86 17.1899V10.5199C6.19237 10.3188 7.26244 9.31634 7.55 7.99992C7.90221 9.59701 9.36806 10.6975 11 10.5899C12.6025 10.6571 14.0225 9.5657 14.37 7.99992C14.6514 9.39922 15.8103 10.4528 17.23 10.5999V17.2399C17.1688 17.9214 16.6041 18.4473 15.92 18.4599V18.4299ZM17.92 8.83992C18.4501 8.82599 18.9413 8.5581 19.24 8.11992V8.14992C19.4475 7.80032 19.4736 7.37209 19.31 6.99992L17.66 2.44992C17.5136 2.15234 17.2006 1.97405 16.87 1.99992H5.12C4.8019 1.97083 4.49641 2.13141 4.34 2.40992L2.69 6.99992C2.47556 7.42433 2.51407 7.93265 2.79 8.31992C3.03924 8.62618 3.39788 8.82343 3.79 8.86992C3.91624 8.88464 4.04376 8.88464 4.17 8.86992C4.93946 8.91195 5.6344 8.41259 5.84 7.66992C5.99257 6.82461 6.72116 6.20489 7.58 6.18992C8.44809 6.1895 9.18683 6.8221 9.32 7.67991C9.52355 8.42717 10.2275 8.92583 11 8.86992C11.7788 8.92182 12.4827 8.40763 12.67 7.64992C12.8146 6.79855 13.5465 6.17184 14.41 6.15991C15.2749 6.15873 16.0124 6.78608 16.15 7.63991C16.3537 8.3927 17.0621 8.8957 17.84 8.83992H17.92Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    E-commerce Excellence
                  </dt>
                  <dd class="mt-2 text-base leading-7 text-gray-600">
                    Power your online sales with our e-commerce solutions,
                    featuring seamless shopping experiences, secure payments,
                    and efficient inventory management.
                  </dd>
                </div>
                <div class="relative pl-16">
                  <dt class="text-base font-semibold leading-7 text-gray-900">
                    <div class="absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-lg bg-olenium-blue">
                      <svg
                        width="18"
                        height="21"
                        viewBox="0 0 18 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clipRule="evenodd"
                          d="M17.5001 2.24996C17.5013 1.69622 17.2728 1.16677 16.8691 0.787725C16.4654 0.408681 15.9227 0.213967 15.3701 0.249962H2.63008C2.07751 0.213967 1.53474 0.408681 1.13106 0.787725C0.727373 1.16677 0.49891 1.69622 0.500081 2.24996V10.81C0.488926 12.2437 1.63644 13.418 3.07008 13.44H6.42008V13.93C6.39612 14.3121 6.27195 14.6811 6.06008 15C5.15277 16.4681 5.4081 18.3726 6.67008 19.55C7.97385 20.7855 10.0163 20.7855 11.3201 19.55C12.0654 18.8714 12.4872 17.9079 12.4801 16.9C12.4994 16.2344 12.3332 15.5765 12.0001 15C11.7674 14.6677 11.6355 14.2753 11.6201 13.87L11.5301 13.42L14.9701 13.51C16.4037 13.488 17.5512 12.3137 17.5401 10.88V9.74996L17.5001 2.24996ZM2.07008 2.24996C2.07008 2.09996 2.07008 1.81996 2.63008 1.81996H15.3701C15.9301 1.81996 15.9301 2.09996 15.9301 2.24996V8.17996H2.07008V2.24996ZM15.0001 12.03C15.5799 11.9773 16.0183 11.4819 16.0001 10.9V9.74996H2.00008V10.81C1.99203 11.1034 2.10162 11.3879 2.30446 11.6002C2.50729 11.8124 2.78655 11.9347 3.08008 11.94H6.50008C7.29147 11.9564 7.92124 12.6085 7.91008 13.4V13.89C7.89387 14.5735 7.68597 15.2388 7.31008 15.81C7.10444 16.1471 6.99708 16.535 7.00008 16.93C7.00059 17.5231 7.25547 18.0874 7.70008 18.48C8.45348 19.1374 9.57668 19.1374 10.3301 18.48C10.7625 18.0813 11.0059 17.5181 11.0001 16.93C11.014 16.5358 10.9206 16.1453 10.7301 15.8C10.353 15.2331 10.1449 14.5706 10.1301 13.89V13.4C10.1247 13.0163 10.2727 12.6464 10.5412 12.3723C10.8097 12.0982 11.1764 11.9426 11.5601 11.94L15.0001 12.03Z"
                          fill="white"
                        />
                        <path
                          d="M4.00016 2.35996C3.58595 2.35996 3.25016 2.69575 3.25016 3.10996V6.57996C3.25016 6.99417 3.58595 7.32996 4.00016 7.32996C4.41437 7.32996 4.75016 6.99417 4.75016 6.57996V3.10996C4.74477 2.698 4.41212 2.36535 4.00016 2.35996Z"
                          fill="white"
                        />
                        <path
                          d="M7.00016 2.35996C6.5882 2.36535 6.25555 2.698 6.25016 3.10996V4.85996C6.25016 5.27418 6.58595 5.60996 7.00016 5.60996C7.41437 5.60996 7.75016 5.27418 7.75016 4.85996V3.10996C7.74477 2.698 7.41212 2.36535 7.00016 2.35996Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    Brand Identity Alignment
                  </dt>
                  <dd class="mt-2 text-base leading-7 text-gray-600">
                    We ensure your website reflects your brand ethos, with
                    custom designs that embody your business values and connect
                    with your target audience.
                  </dd>
                </div>
                <div class="relative pl-16">
                  <dt class="text-base font-semibold leading-7 text-gray-900">
                    <div class="absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-lg bg-olenium-blue">
                      <svg
                        width="18"
                        height="20"
                        viewBox="0 0 18 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.88002 5.47025C8.03502 5.47025 7.35002 6.15525 7.35002 7.00025C7.35002 7.84524 8.03502 8.53025 8.88002 8.53025C9.72501 8.53025 10.41 7.84524 10.41 7.00025C10.4046 6.15752 9.72274 5.4757 8.88002 5.47025Z"
                          fill="white"
                        />
                        <path
                          d="M8.13002 10.2502C8.13541 9.83828 8.46806 9.50563 8.88002 9.50025C9.29198 9.50563 9.62464 9.83828 9.63002 10.2502V12.0002C9.63002 12.4145 9.29423 12.7502 8.88002 12.7502C8.46581 12.7502 8.13002 12.4145 8.13002 12.0002V10.2502Z"
                          fill="white"
                        />
                        <path
                          fill-rule="evenodd"
                          clipRule="evenodd"
                          d="M14.66 12.0702L16.76 12.7702C17.3424 12.9713 17.7376 13.5142 17.75 14.1302V18.1302C17.75 19.163 16.9128 20.0002 15.88 20.0002C15.6791 20.0004 15.4796 19.9666 15.29 19.9002L14.29 19.5602C14.0041 19.8466 13.6146 20.0053 13.21 20.0002H11.69C10.9826 20.0404 10.3734 19.5067 10.32 18.8002V16.1902C10.2666 15.4451 9.626 14.8802 8.88002 14.9202C8.13404 14.8802 7.49347 15.4451 7.44002 16.1902V18.8002C7.38666 19.5067 6.77739 20.0404 6.07002 20.0002H4.55002C4.14541 20.0053 3.75593 19.8466 3.47002 19.5602L2.47002 19.9002C2.2804 19.9666 2.08092 20.0004 1.88002 20.0002C0.858781 20.0059 0.0218467 19.1913 1.75681e-05 18.1702V14.1702C-0.00306542 13.5369 0.399886 12.9727 1.00002 12.7702L3.10002 12.0702V8.89025C3.1713 5.36552 5.01833 2.11534 8.01002 0.250247C8.26991 0.0849064 8.572 -0.00190155 8.88002 0.000247054C9.18827 -0.00364199 9.49085 0.083306 9.75002 0.250247C12.7417 2.11534 14.5887 5.36552 14.66 8.89025V12.0702ZM1.98001 18.4802L2.30001 18.3702L2.33001 13.9202L1.51001 14.1902V18.1302C1.51001 18.3346 1.67567 18.5002 1.88001 18.5002L1.98001 18.4802ZM13.06 18.3702H11.88V16.1902C11.8104 14.5844 10.4874 13.3187 8.88002 13.3202C7.27263 13.3187 5.94967 14.5844 5.88002 16.1902V18.4002H4.70002V8.89025C4.78264 5.91302 6.35231 3.17549 8.88002 1.60025C11.4145 3.17507 12.9885 5.9175 13.07 8.90025L13.06 18.3702ZM15.9 18.4702C16.1044 18.4702 16.27 18.3046 16.27 18.1002V14.1702L15.46 13.9002V18.3602L15.78 18.4702H15.9Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    Analytics and Reporting Tools
                  </dt>
                  <dd class="mt-2 text-base leading-7 text-gray-600">
                    Gain valuable insights into user behavior with integrated
                    analytics, helping you make data-driven decisions for
                    continual improvement.
                  </dd>
                </div>
              </dl>
              <Link
                to="https://portal.olenium.co.uk"
                // close the modal when the user clicks the button
                onClick={toggleModal}
                class="block w-full rounded-lg bg-olenium-blue px-3 py-3 text-center text-sm font-semibold text-white shadow-sm hover:bg-olenium-blue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-olenium-blue"
              >
                Get started
              </Link>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
